import {
    IStackStyles,
    Stack
} from "@fluentui/react";
import { CustomFontText } from "components/customFontText/CustomFontText";
import React from "react";
import { Col, Row } from "react-grid-system";
import {
    useSelector
} from "react-redux";
import { AppState } from "store/index";
import { isKarlProfile } from "utils/permissions/permissionsHelpers";


const container: IStackStyles = {
    root: {
        marginTop: 10,
        minHeight: 500
    },
};

export const FinanceScorecardReport = () => {

    const user = useSelector((state: AppState) => state.userProfile.userProfile) as any;
    const isKarlProfileType = user.profileType && isKarlProfile(user.profileType);
    return (
        isKarlProfileType ? <>
            <div className="reportFinanceProductWidth">
                <Stack styles={container} tokens={{ childrenGap: 10 }}>
                    <Stack
                        horizontal
                        verticalAlign="center"
                        horizontalAlign="space-between"
                        className="loc_btn_par_con"
                    >
                        <Row>
                            <Col className="alignHeaders">
                                <CustomFontText className="pageTitleFont pageName pageHeaderFont">F&I Scorecard</CustomFontText>
                            </Col>
                        </Row>
                    </Stack>
                    <div className="deskReport reportHeaderPart tablePadSizeWidth datatable-filter-demo trade-in-workboook dropDownBorderColor">
                       <iframe  title="F&I Scorecard Report" style={{width:'100%',height:"68vh"}} src="https://fiqore.clicdata.com/v/finance_scorecard"></iframe>
                    </div>
                </Stack>
            </div>
        </> : null
    );
};


